<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M14.0998 12.4029C17.1998 12.4029 19.7998 9.9029 19.7998 6.7029C19.7998 3.6029 17.2998 1.0029 14.0998 
    1.0029C10.8998 0.902898 8.2998 3.4029 8.2998 6.6029C8.2998 9.8029 10.8998 12.4029 14.0998 12.4029Z"
    fill="#748097"
  />
  <path
    d="M29.6923 28.2457L26 24.5885C25.2821 23.8774 24.1538 23.7758 23.3333 24.1822L20.0513 20.9314V19.0012L16.6667 
    16.4616C16.359 16.1568 15.8462 16.2584 15.5385 16.5631L14.6154 17.4774C14.3077 17.7822 14.3077 18.2901 14.5128 
    18.5949L17.0769 21.9473H19.0256L22.3077 25.1981C21.8974 26.0108 22 27.1282 22.7179 27.8393L26.4103 31.4965C26.8205 
    31.9028 27.641 31.9028 28.0513 31.4965L29.6923 29.8711C30.1026 29.4647 30.1026 28.652 29.6923 28.2457ZM24.359 
    22.9631C25.2821 22.9631 26.1026 23.2679 26.7179 23.8774L27.3333 24.487C27.8462 24.2838 28.2564 23.979 28.6667 
    23.5727C29.7949 22.4552 30.2051 20.8298 29.8974 19.306C29.7949 19.0012 29.4872 18.8997 29.2821 19.1028L26.9231 
    21.4393L24.7692 21.1346L24.4615 19.0012L26.8205 16.6647C27.0256 16.4616 26.9231 16.1568 26.6154 16.0552C25.1795 
    15.6489 23.5385 16.0552 22.3077 17.2743C21.3846 18.1885 20.9744 19.306 20.9744 20.5251L23.5385 23.0647C23.8462 
    22.9631 24.0513 22.9631 24.359 22.9631ZM21.0769 25.5028L19.3333 23.7758L14.6154 28.4489C13.7949 29.2616 13.7949 
    30.4806 14.6154 31.2933C15.4359 32.106 16.6667 32.106 17.4872 31.2933L21.3846 27.433C20.9744 26.8235 20.9744 
    26.1124 21.0769 25.5028ZM15.9487 30.5822C15.5385 30.5822 15.2308 30.2774 15.2308 29.8711C15.2308 29.4647 15.5385 
    29.16 15.9487 29.16C16.359 29.16 16.6667 29.4647 16.6667 29.8711C16.7692 30.2774 16.359 30.5822 15.9487 30.5822Z"
    fill="#009DD6"
  />
  <path
    d="M18.1 23.1029H16.5L13.6 19.3029C13 18.4029 13 17.2029 13.8 16.5029L14.7 15.6029C15.1 15.2029 15.7 15.0029 
    16.2 15.0029C16.7 15.0029 17.1 15.1029 17.5 15.4029L20.4 17.6029C20.6 17.2029 21 16.7029 21.3 16.4029C21.5 
    16.2029 21.8 16.0029 22 15.8029C20.9 15.1029 19.7 14.7029 18.3 14.7029H9.7C5.9 14.7029 3 17.7029 3 21.4029V23.9029C3 
    24.5029 3.4 24.9029 4 24.9029H16.3L18.1 23.1029Z"
    fill="#748097"
  />
</svg>
